var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 14.076
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.251 1.168C18.531.31 17.161 0 14.619 0H5.375C2.775 0 1.35.213.627 1.129c-.7.89-.626 2.361-.626 4.18v3.464c0 1.968.135 3.451 1.161 4.322.806.69 2.213.981 4.219.981h9.238c2.206 0 3.548-.148 4.341-.9.813-.774 1.039-2.206 1.039-4.4V5.309c0-1.916-.019-3.283-.748-4.141zm-6.412 6.347L8.646 9.708a.61.61 0 01-.3.071.688.688 0 01-.335-.09.647.647 0 01-.31-.555V4.767a.636.636 0 01.31-.548.649.649 0 01.632-.019l4.193 2.18a.637.637 0 010 1.135z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/youtube_full.e5d691098b43e3c9c012d4a7350ed983.svg";
export { SvgYoutubeFull as ReactComponent };